package com.xtream.data_kmp.remote

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.cache.HttpCache
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.plugins.logging.SIMPLE
import io.ktor.client.request.header
import io.ktor.http.HttpHeaders
import io.ktor.serialization.kotlinx.json.json

actual fun platformClient(): HttpClient = HttpClient(Js) {

    install(HttpCache)

    install(ContentNegotiation) {
        json(ApiService.jsonObj)
    }

    install(Logging) {
        logger = Logger.SIMPLE
        level = LogLevel.HEADERS
    }

    defaultRequest {
        // ❌ REMOVED - these trigger CORS preflight
        // contentType(ContentType.Application.Json)
        // accept(ContentType.Application.Json)
        // header(HttpHeaders.CacheControl, "no-cache")
        // header(HttpHeaders.Pragma, "no-cache")

        // ✅ Only simple request headers - no preflight triggered
        header(HttpHeaders.Accept, "*/*")
        header(HttpHeaders.AcceptLanguage, "en-US,en;q=0.9")
        header(
            HttpHeaders.UserAgent,
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/149.0.0.0 Safari/537.36"
        )
    }

    engine {
        // no config needed
    }
}